import { HttpBackend, HttpClient } from '@angular/common/http';
import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { Utenteservice } from '../../services/utente.service';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-giacenze-rifiuti',
  templateUrl: './giacenze-rifiuti.component.html',
  styleUrls: ['./giacenze-rifiuti.component.css']
})
export class GiacenzeRifiutiComponent extends NicaMaster implements OnInit {
  @ViewChild('formStatisticaGiacenze', { static: false }) formStatisticaGiacenze: NicaAnagraficaComponent;
  @ViewChild('filtroForm', { static: false }) filtroForm: NicaFormComponent;
  @Input() itemData: any;
  @Output() emittedData: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  currentParams: any
  currentFilter: ''
  datiJson
  ROW
  showDynamicGiacenza: boolean = false
  magazzini: any;
  hireDateEditorOptions: Object;
  dt: any;
  initialQuery: boolean = true;
  currentSoggetto;
  currentSede;
  currentData;
  currentMagazzini = [];
  currentCantieri = [];
  currentPosizioni;
  //currentRaggruppa;
  showDynamicPopOver = false;
  now: Date = new Date();
  Data = new Date();
  DettagliaRiferimenti: boolean = true;
  isEscludiCantieriFouriUl: boolean = false;
  myfilter: string = "?load=true";
  myfilterFlag: boolean = false;
  myfilterDett: string = '';
  isFromMenu: boolean = true;
  posizioni;
  myFilerMovimenti: string;
  ListaTipoCarico: any;
  StatoFisico: any;
  constructor(
    private activateRoute: ActivatedRoute,
    public overlaySideService: OverlaySideFormService,
    public httpClient: HttpClient,
    public _overlaySideFormService: OverlaySideFormService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public spinner: NgxSpinnerService,
    public userComponentService: ComponentService,
    public appService: Apiservice,
    public activatedroute: ActivatedRoute,
    public httpBackend: HttpBackend,
    public utenteService: Utenteservice,
    public templateService: FormsTemplateService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,
    );
    this.appService.GetApi('PosizioneRifiuti').then(result => {
      this.currentPosizioni = [];
      this.posizioni = result['items'];
      //this.CalcoloQuery();
    })

    this.hireDateEditorOptions = {
      onValueChanged: (e) => {
        if (e.value && this.currentMagazzini && this.currentPosizioni.length > 0 && this.currentMagazzini.length > 0) this.CalcoloQuery();
      },
      type: 'date', format: "dd-MM-yyyy",
      width: '100%',
      value: new Date()
    };
    this.dt = {};
  }
  CalcoloQuery() {
    if (this.filtroForm) {
      let valori = this.filtroForm.formEdit.formData;
      if (valori.IsEscludiCantieriFouriUl === undefined || valori.IsEscludiCantieriFouriUl === null) valori.IsEscludiCantieriFouriUl = false
      this.userComponentService.setOpzionalParameter('formData', valori, this.currentTabId)
      this.currentPosizioni = valori.idPosizioneRifiuto
      this.isEscludiCantieriFouriUl = valori.IsEscludiCantieriFouriUl
    }

    if (this.currentSede < 1) return;

    if (this.currentSede < 1 || this.currentMagazzini.length == 0 || this.currentPosizioni.length == 0 || !this.currentData) {
      this.myfilter = "?IdSedeDestinatario=0&load=true"
      this.formStatisticaGiacenze.refresh();
      return;
    }

    const moment = require('moment');
    let ttt = moment(this.dt.Data).format("YYYY-MM-DD")
    let ttt1 = moment(this.dt.Data).format("DD-MM-YYYY")

    this.myfilter = "?IdSedeDestinatario=" + this.currentSede;//+"&ListIdMagazzino=["+this.currentMagazzini+"]&AllaData="+ttt;
    for (let i = 0; i < this.currentMagazzini.length; i++) {
      this.myfilter += "&ListIdMagazzino=" + this.currentMagazzini[i]
    }
    if (this.currentCantieri && this.currentCantieri !== undefined && this.isEscludiCantieriFouriUl == false)
      for (let i = 0; i < this.currentCantieri.length; i++) {
        this.myfilter += "&ListIdCantieri=" + this.currentCantieri[i]
      }

    for (let i = 0; i < this.currentPosizioni.length; i++) {
      this.myfilter += "&ListIdPosizioni=" + this.currentPosizioni[i]
    }
    this.myfilter += "&AllaData=" + this.currentData;// ttt;
    this.myfilter += "&DettagliaRiferimenti=" + this.DettagliaRiferimenti;

    this.myfilter += "&IsEscludiCantieriFouriUl=" + this.isEscludiCantieriFouriUl;
    {
      this.formStatisticaGiacenze.refresh();
      setTimeout(() => {
        this.formStatisticaGiacenze.griglia.instance.clearSelection();
        this.myfilterDett = '';
      }, 200);
    }
    console.log("ecco la lista dei  magazzini ", this.currentMagazzini)
  }

  CalcoloDettMovimenti(tp, event) {

    let row = this.ROW
    console.log("ROWWWWWWWWWWWWW ", row);
    const moment = require('moment');

    this.myFilerMovimenti = "?IdSedeDestinatario=" + this.currentSede;//+"&ListIdMagazzino=["+this.currentMagazzini+"]&AllaData="+ttt;
    for (let i = 0; i < this.currentMagazzini.length; i++) {
      this.myFilerMovimenti += "&ListIdMagazzino=" + this.currentMagazzini[i]
    }
    if (this.currentCantieri !== undefined && this.isEscludiCantieriFouriUl == false)
      for (let i = 0; i < this.currentCantieri.length; i++) {
        this.myFilerMovimenti += "&ListIdCantieri=" + this.currentCantieri[i]
      }
    //ListIdTipoCarico this.ListaTipoCarico

    if (tp == '') {
      for (let i = 0; i < this.ListaTipoCarico.length; i++) {
        this.myFilerMovimenti += "&ListIdTipoCarico=" + this.ListaTipoCarico[i]['id']
      }
    } else this.myFilerMovimenti += "&ListIdTipoCarico=" + tp

    for (let i = 0; i < this.currentPosizioni.length; i++) {
      this.myFilerMovimenti += "&ListIdPosizioni=" + this.currentPosizioni[i]
    }
    this.myFilerMovimenti += "&AllaData=" + this.currentData;// ttt;
    this.myFilerMovimenti += "&DettagliaRiferimenti=" + this.DettagliaRiferimenti;

    this.myFilerMovimenti += "&IsEscludiCantieriFouriUl=" + this.isEscludiCantieriFouriUl;
    this.myFilerMovimenti += "&EER=" + row.eer;//ListaMovimentiGiacenza
    this.myFilerMovimenti += "&RiferimentoEER=" + row.riferimentoEER;//ListaMovimentiGiacenza
    this.myFilerMovimenti += "&idStatoFisico=" + row.idStatoFisico;

    if (event && event.component) event.component.refresh();

  }



  CalcoloDett(row, event) {
    this.ROW = row
    console.log("ROWWWWWWWWWWWWW ", row);
    const moment = require('moment');

    this.myFilerMovimenti = "?IdSedeDestinatario=" + this.currentSede;//+"&ListIdMagazzino=["+this.currentMagazzini+"]&AllaData="+ttt;
    for (let i = 0; i < this.currentMagazzini.length; i++) {
      this.myFilerMovimenti += "&ListIdMagazzino=" + this.currentMagazzini[i]
    }
    if (this.currentCantieri !== undefined && this.isEscludiCantieriFouriUl == false)
      for (let i = 0; i < this.currentCantieri.length; i++) {
        this.myFilerMovimenti += "&ListIdCantieri=" + this.currentCantieri[i]
      }
    //ListIdTipoCarico this.ListaTipoCarico
    if (this.ListaTipoCarico)
      for (let i = 0; i < this.ListaTipoCarico.length; i++) {
        this.myFilerMovimenti += "&ListIdTipoCarico=" + this.ListaTipoCarico[i]['id']
      }
    for (let i = 0; i < this.currentPosizioni.length; i++) {
      this.myFilerMovimenti += "&ListIdPosizioni=" + this.currentPosizioni[i]
    }
    this.myFilerMovimenti += "&AllaData=" + this.currentData;// ttt;
    this.myFilerMovimenti += "&DettagliaRiferimenti=" + this.DettagliaRiferimenti;

    this.myFilerMovimenti += "&IsEscludiCantieriFouriUl=" + this.isEscludiCantieriFouriUl;
    this.myFilerMovimenti += "&EER=" + row.eer;//ListaMovimentiGiacenza
    this.myFilerMovimenti += "&RiferimentoEER=" + row.riferimentoEER;//ListaMovimentiGiacenza
    this.myFilerMovimenti += "&idStatoFisico=" + row.idStatoFisico;
    this.StatoFisico = row.idStatoFisico

    if (event && event.component) event.component.refresh();

  }

  changeRiferimenti(e) {
    const guid = Math.random().toString().replace("0.", "")
    const dataSend = {
      guid: guid
    }
    this.userComponentService.setNewPopUp(guid, 'EditgiacenzainizialeComponent', null, '1400', null, dataSend, false, true, 'Dettaglio Giacenze', 'center', '')
    this.userComponentService.outputComponent.subscribe((res) => {
      // console.log(res)

    })
    // this.userComponentService.openComponent("EditgiacenzainizialeComponent", dataSend, "Giacenze Iniziali", 1260, 700)
    // this.userComponentService.closeOverlayForm().subscribe(res => { })
    this.CalcoloQuery();
  }
  SedeChanged(e) {
    alert("cambiatooooooooo", 'cambiato')
    this.myfilter = '?load=true';
    this.myfilterFlag = false;
    this.myfilterDett = '';
    if (e == null) {
      this.currentMagazzini = [];
      this.magazzini = [];
      this.currentCantieri = [];
      return;
    }
    this.currentSede = e.id;
    this.appService.GetApi('MagazzinoRifiuti?idSede=' + e.id).then(result => {
      this.currentMagazzini = [];
      this.magazzini = result['items']
    })
  }
  SoggettoChanged(e) {
    this.myfilter = '?load=true';
    this.myfilterDett = '';
    this.myfilterFlag = false;
    this.currentSoggetto = e.id;
    console.log("SoggettoChanged ", e)

  }
  optionalButton(e) {
    //GiacenzaIniziale
    if (e.name == 'GiacenzaIniziale') {
      const guid = Math.random().toString().replace("0.", "")
      console.log("INSERSCO GIACENZA ", e)
      const dataSend = {
        itemData: {
          id: e.row.data.idGiacenzaIniziale,
          ChiudiDopoModifica: true
        },
        guid: guid
      }
      // this.userComponentService.openComponent("EditgiacenzainizialeComponent", dataSend, "Giacenze Iniziali", 1400, 700)
      // this.userComponentService.closeOverlayForm().subscribe(res => {
      //   this.CalcoloQuery();
      // })

      this.userComponentService.setNewPopUp(guid, 'EditgiacenzainizialeComponent', null, '1400', null, dataSend, false, true, 'Dettaglio Giacenze', 'center', '')
      this.userComponentService.outputComponent.subscribe((res) => {
        // console.log(res)

      })
    }

    if (e.name == 'dettagli') {
      // alert("Al momento Funzione non disponibile","NOTIZIE DA IGNAZIO")
      this.CalcoloDett(e.row.data, null)
      if (this.myFilerMovimenti > '') {
        const dataToSend = {
          id: "formStatisticaGiacenzeDett",
          orientamento: "l",
          formato: 'a4',
          titolo: 'Dettaglio Giacenze',
          sommaGrouping: false,
          aggiungi: false,
          modifica: false,
          // columnAutoWidth:true,
          onlyTitle: true,
          masterKey: 'id',
          gridHeight: 500,
          name: "formStatisticaGiacenzeDettaglio",
          columnAutoWidth: false,
          elimina: false,
          wingap: true,
          filter: this.myFilerMovimenti,
          ricerca: true,
          remoteOperations: false,
          paginate: false,
          dxoscrolling: "virtual",
          dxosorting: "multiple",
          dxocolumnchooser: false,
          editorType: "",
          api: "GiacenzaRifiuti/ElencoMovimentiByGiacenza",
          service: "ListaMovimentiGiacenza"

        }
        const guid = Math.random().toString().replace("0.", "")
        this.userComponentService.setNewPopUp(guid, 'NicaAnagraficaComponent', null, '1600', null, dataToSend, true, true, 'Dettaglio Giacenze', 'center', '')
        this.userComponentService.outputComponent.subscribe((res) => {
          // console.log(res)
          this.AllEventLista(res, null)
          if (res.name === 'checkLoad') {
            this.checkGetAllGiacenza(res)
          }
        })
      }
    }

  }

  checkGetAllGiacenza(e: any) {
    console.log("ecco le giacenze lette", e)
    if (this.currentFilter > '') {
      for (let i = 0; i < e.data.length; i++) {
        if (e.data[i]['idTipoCarico'] == null)
          e.data[i]['idTipoCarico'] = this.currentFilter
      }
      return e.data;
    }
    //idTipoCarico
  }
  checkGetAll(e: any) {

    console.log("ecco i dati iiiii", e)
    if (e.componentName == 'formStatisticaGiacenze') {

      for (let i = 0; i < e.data.length; i++) {
        const moment = require('moment');
        let ttt = moment(this.dt.Data).format("YYYY-MM-DD")
        let ttt1 = moment(this.dt.Data).format("DD-MM-YYYY")

        e.data[i].linkExpand = "?IdSedeDestinatario=" + this.currentSede;//+"&ListIdMagazzino=["+this.currentMagazzini+"]&AllaData="+ttt;
        for (let ii = 0; ii < this.currentMagazzini.length; ii++) {
          e.data[i].linkExpand += "&ListIdMagazzino=" + this.currentMagazzini[ii]
        }
        for (let ii = 0; ii < this.currentPosizioni.length; ii++) {
          e.data[i].linkExpand += "&ListIdPosizioni=" + this.currentPosizioni[ii]
        }
        e.data[i].linkExpand += "&AllaData=" + this.currentData;// ttt;
        e.data[i].linkExpand += "&DettagliaRiferimenti=" + this.DettagliaRiferimenti;


        e.data[i].linkExpand += "&eer=" + e.data[i].eer;
        e.data[i].linkExpand += "&idStatoFisico=" + e.data[i].idStatoFisico;
        e.data[i].linkExpand += "&riferimentoEER=" + e.data[i].riferimentoEER;




      }
      return e.data;
    }
    else return null;
  }
  AllEventLista(event, options) {
    //console.log(" EVENT ON LISTA MOVIMENTI ",event.name)
    // if (event.name == 'onContentReady') {
    //   let actual = event.component.instance.getCombinedFilter();
    //   let fil = '';
    //   if (actual) {
    //     let x = actual.filterValue;
    //     if (x != this.currentFilter) {
    //       this.currentFilter = x;
    //       this.CalcoloDettMovimenti(x, event)
    //     }
    //   }
    //   if (!actual && this.currentFilter > '') {
    //     this.CalcoloDettMovimenti('', event)
    //     this.currentFilter = '';
    //   }
    // }
    if (event.name == 'onCellPrepared') {
      if (event.rowType === "data" && event.column.command === "expand") {
        if (event.data.causale_Id_Operazione == 'GI') {
          var $links = event.cellElement.firstChild
          $links.classList.remove("dx-datagrid-group-closed");
        }
      }
    }


    if (event.name == "onInitilized") {
      this.movimentoDetailInit(event)
      // event.contentComponent.changeTitoloGriglia("wwwwwwwwwwwwwwwwww")
    }
  }
  AllEvent(e) {
    if (e.name == "onCellPrepared") {
      if (e.rowType === "data" && e.dataField == "eer") {
        if (e.data.isPericoloso == true) {
          e.cellElement.innerHTML += "<span style='color:red'> *</span>";
        }

      }
      if (e.rowType === "data" && e.dataField == "idStatoFisico") {
        e.cellElement.innerHTML = e.value + " - " + e.text;
      }
      if (e.rowType === "data" && e.column.command == "edit") {
        if (e.data.idGiacenzaIniziale == '') {
          var $links = e.cellElement.firstChild
          $links.classList.remove("dx-icon-edit");

        }
      }
    }
    if (e.name == "onSelectionChanged") {
      this.outputEmit.emit(e)
    }
    //      onInitNewRow
    if (e.name == "onInitNewRow") {
      e.cancel = true;
      if (!this.filtroForm.formEdit.instance.validate().isValid) {
        e.cancel = true;
        return;
      }

      e = this.filtroForm.formEdit.formData;
      const guid = Math.random().toString().replace("0.", "")
      if (!e.idCantiere) e.idCantiere = [];
      let idD = e.idDestinatario;
      let idMagazzino = (e.idMagazzino.length == 1) ? e.idMagazzino[0] : null;
      let idPos = (e.idPosizioneRifiuto.length == 1) ? e.idPosizioneRifiuto[0] : null;
      let idCantiere = (e.idCantiere.length == 1) ? e.idCantiere[0] : null;
      const dataSend = {
        itemData: {
          idDestinatario: idD,
          idPosizioneRifiuto: idPos,
          idMagazzino: idMagazzino,
          idCantiere: idCantiere
        },
        guid: guid
      }

      // this.userComponentService.openComponentCustom("EditgiacenzainizialeComponent", dataSend, "Giacenze Iniziali", 1250, 700, false)
      // this.userComponentService.closeOverlayForm().subscribe(res => {
      //   this.formStatisticaGiacenze.refresh();
      // })

      this.userComponentService.setNewPopUp(guid, 'EditgiacenzainizialeComponent', null, '1400', null, dataSend, false, true, 'Dettaglio Giacenze', 'center', '')
      this.userComponentService.outputComponent.subscribe((res) => {
        // console.log(res)

      })
    }
  }




  ngOnInit() {

    this.appService.GetApi('TipoCarico').then(r => {
      this.ListaTipoCarico = r['items'];
    })

    this.activateRoute.queryParams.subscribe(params => {
      this.params = params
      this.currentTabId = this.params.currentTabId;
      this.datiJson = {
        analisiData: new Date(),
        DettagliaRiferimenti: true
      }

      let formData = this.userComponentService.getOpzionalParameter('formData', this.currentTabId)
      if (formData) {
        this.spinner.show();
        this.datiJson = formData;
        this.currentCantieri = formData.idCantiere;
        this.currentSede = formData.idDestinatario;
        this.currentMagazzini = formData.idMagazzino;
        this.currentPosizioni = formData.idPosizioneRifiuto;
        this.currentData = formData.analisiData
        if (this.datiJson.isEscludiCantieriFouriUl === undefined) this.datiJson.isEscludiCantieriFouriUl = false
        if (this.datiJson.DettagliaRiferimenti === undefined) this.datiJson.DettagliaRiferimenti = true

        setTimeout(() => {
          this.spinner.hide();
          this.CalcoloQuery();
        }, 500);
      }
      this.currentParams = Object.assign({}, params);
      this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName
      this.setGlobalVariableFromParams(params);
    })

    const moment = require('moment');
    this.currentData = moment(new Date()).format("YYYY-MM-DD");
    this.DettagliaRiferimenti = true;


    if (this.itemData) {
      if (this.itemData[0].nomeTabRif == 'movimenti') {

        this.isFromMenu = false;
        let datiFromMovimento = this.itemData[0]['dati'];

        const idOperazione = datiFromMovimento.idOperazione;

        let idMagazzinoDestinatario

        //A1 A2 A4 A5 B1 B2 C3

        if (idOperazione == 'A1' || idOperazione == 'A2' || idOperazione == 'A4' || idOperazione == 'A5' || idOperazione == 'B1' || idOperazione == 'B2') {
          this.currentSede = datiFromMovimento.idDestinatario;
          if (!datiFromMovimento.idMagazzinoDestinatario) {

            this._overlaySideFormService.close();
            alert('Selezionare Magazzino', 'Attenzione!');
            return
          }
          idMagazzinoDestinatario = datiFromMovimento.idMagazzinoDestinatario;
        }

        if (idOperazione == 'C1' || idOperazione == 'C2' || idOperazione == 'C3') {
          this.currentSede = datiFromMovimento.idProduttore;

          if (!datiFromMovimento.idMagazzinoProduttore) {
            this._overlaySideFormService.close()

            alert('Selezionare Magazzino', 'Attenzione!');
            return
          }

          idMagazzinoDestinatario = datiFromMovimento.idMagazzinoProduttore;
        }

        const moment = require('moment');
        let dataRegistrazione = moment(datiFromMovimento['dataRegistrazione']).format("YYYY-MM-DD");
        let dataParsed = moment(datiFromMovimento['dataRegistrazione']).format("DD-MM-YYYY");

        setTimeout(() => {
          this.formStatisticaGiacenze.changeTitoloGriglia("Giacenze al: " + dataParsed)
        }, 500);

        this.myfilter = "?IdSedeDestinatario=" + this.currentSede;//+"&ListIdMagazzino=["+this.currentMagazzini+"]&AllaData="+ttt;

        this.myfilter += "&ListIdMagazzino=" + idMagazzinoDestinatario

        this.myfilter += "&AllaData=" + dataRegistrazione;
        this.myfilterFlag = true;
      }
    }
  }

  emittendButtonPushX(e) {
    //dataField
    if (e.name == "onValueChange" && e.campo.dataField == 'DettagliaRiferimenti') {
      this.DettagliaRiferimenti = e.value;
      this.CalcoloQuery();
    }
    if (e.name == "onValueChange" && e.campo.dataField == 'isEscludiCantieriFouriUl') {
      this.isEscludiCantieriFouriUl = e.value;
      if (e.value == true) e.masterComponent.getEditor("idCantiere").option("disabled", true)
      else e.masterComponent.getEditor("idCantiere").option("disabled", false)
      this.CalcoloQuery();
    }

    if (e.name == "selectedItemTag") {
      if (e.formData.idCantiere)
        this.currentCantieri = e.formData.idCantiere;
      if (e.formData.idMagazzino)
        this.currentMagazzini = e.formData.idMagazzino;
      if (e.formData.idPosizioneRifiuto)
        this.currentPosizioni = e.formData.idPosizioneRifiuto;
      if (e.formData.idDestinatario)
        this.currentSede = e.formData.idDestinatario;

      this.CalcoloQuery();
    }
    if (e.name == "formDataChanged") {
      if (e.formDataChanged.analisiData) {
        this.currentData = e.formDataChanged.analisiData;
        const moment = require('moment');
        this.currentData = moment(new Date(this.currentData)).format("YYYY-MM-DD");

      } else {
        const moment = require('moment');
        this.currentData = moment(new Date()).format("YYYY-MM-DD");
      }
      if (e.formDataChanged.DettagliaRiferimenti != undefined)
        this.DettagliaRiferimenti = e.formDataChanged.DettagliaRiferimenti;

      this.CalcoloQuery();


    }

    //submittedInsertOk submittedEditOk onSavingonFormSubmit
    if (e.eventName == 'onSavingonFormSubmit') {
      return true;
    }
    //
    if (e.event == 'elaboraGiacenza') {
      this.currentSede = e.data.idDestinatario;
      //this.currentData;
      this.currentMagazzini = e.data.idMagazzino;
      this.currentPosizioni = e.data.idPosizioneRifiuto;
      //this.currentRaggruppa;

      let idD = e.data.idDestinatario;
      let idMagazzino = e.data.idMagazzino;
      let idPos = e.data.idPosizioneRifiuto;
      let analisiData = e.data.analisiData;
      const dataSend = {
        idDestinatario: idD,
        idPosizioneRifiuto: idPos,
        idMagazzino: idMagazzino
      }

      //?\aData=2025-01-01&IdSedeDestinatario=1&ListIdMagazzino=1&ListIdPosizioni=1&load=false
      let filter = "?AllaData=" + analisiData + "&IdSedeDestinatario=" + idD + "&ListIdMagazzino=" + idMagazzino + "&ListIdPosizioni=" + idPos + "&load=false&dettagliaRiferimenti=" + e.data.DettagliaRiferimenti;
      this.myfilter = filter;
      this.formStatisticaGiacenze.refresh();
    }
    if (e.event == 'inserisciGiacenza') {
      const guid = Math.random().toString().replace("0.", "")
      if (!e.data.idCantiere) e.data.idCantiere = [];
      let idD = e.data.idDestinatario;
      let idMagazzino = (e.data.idMagazzino.length == 1) ? e.data.idMagazzino[0] : null;
      let idPos = (e.data.idPosizioneRifiuto.length == 1) ? e.data.idPosizioneRifiuto[0] : null;
      let idCantiere = (e.data.idCantiere.length == 1) ? e.data.idCantiere[0] : null;
      const dataSend = {
        itemData: {
          idDestinatario: idD,
          idPosizioneRifiuto: idPos,
          idMagazzino: idMagazzino,
          idCantiere: idCantiere
        },
        guid: guid
      }

      // this.userComponentService.openComponent("EditgiacenzainizialeComponent", dataSend, "Giacenze Iniziali", 1400, 700)
      // this.userComponentService.closeOverlayForm().subscribe(res => {
      // })

      this.userComponentService.setNewPopUp(guid, 'EditgiacenzainizialeComponent', null, '1400', null, dataSend, false, true, 'Dettaglio Giacenze', 'center', '')
      this.userComponentService.outputComponent.subscribe((res) => {
        // console.log(res)

      })
    }
  }
  movimentoDetailInit(event) {
    let masterDetail = this.formTemplateService.getTemplateService('DammiInfoMovimentoGiacenze')
    event.component.option('masterDetail', masterDetail);
  }
}
